<template>
  <standard-layout :header="`${order.customer.lastName}, ${order.createdTime.toLocaleString()}`" v-if="order"
                   type="order">
    <template v-slot:main>
      <order-detail :order="order" @changed="loadOrder" :panel-layout="true"/>
      <div class="p-1 mt-3">
        <button v-if="order.state !== 'fulfilled' && order.state !== 'canceled'" class="btn btn-success btn-sm mr-2 mt-1"
                @click="markAsFulfilled(false)">
          Als geleistet verbuchen
        </button>
        <button v-if="order.state !== 'fulfilled' && order.state !== 'canceled'" class="btn btn-success btn-sm mr-2 mt-1"
                @click="markAsFulfilled(true)">
          Als geleistet verbuchen (ohne Benachrichtigung)
        </button>
        <button v-if="!invoice" class="btn btn-success btn-sm mr-2 mt-1"
                @click="generateInvoiceAndSent">
          Rechnung generieren und versenden
        </button>
        <button class="btn btn-danger btn-sm mt-1"
                @click="cancel"
                v-if="order.state !== 'canceled' && !(order.reservation && order.state === 'fulfilled')">
          <!-- entweder die Bestellung wurde noch nicht storniert und es ist keine erbrachte Reservierung -->
          Komplett stornieren
        </button>
      </div>
      <reservation-detail class="mt-2" v-if="order.reservation" :reservation="order.reservation"/>
      <div class="mt-2" v-if="voucher">
        <voucher-detail v-if="voucher.code" :voucher="voucher"/>
        <div v-else class="btn btn-primary" @click="generateVoucher">
          Gutschein generieren
        </div>
      </div>
      <customer-detail class="mt-2" :customer="order.customer"/>
      <invoice-detail class="mt-2" :invoice="invoice"/>
    </template>
  </standard-layout>
</template>

<script>
import OrderDetail from "@/components/order/OrderDetail";
import StandardLayout from "@/layouts/StandardLayout";
import CustomerDetail from "@/components/customer/CustomerDetail";
import ReservationDetail from "@/components/reservation/ReservationDetail";
import InvoiceDetail from "@/components/invoice/InvoiceDetail";
import VoucherDetail from "@/components/voucher/VoucherDetail";

export default {
  components: {VoucherDetail, InvoiceDetail, ReservationDetail, StandardLayout, OrderDetail, CustomerDetail},
  props: {
    id: String
  },
  data() {
    return {
      order: undefined,
      invoice: undefined,
      voucher: undefined
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: 'loadOrder'
    },
    $route: {
      immediate: true,
      handler: 'loadOrder'
    }
  },
  methods: {
    async loadOrder() {
      console.log('loadOrder() ' + this.id + "/" + this.$route.query.number)
      if (this.id || this.$route.query.number) {
        const url = this.id ? `/orders/${this.id}` : `/orders?number=${this.$route.query.number}`
        await this.$api.get(url)
            .then(res => {
              this.order = Array.isArray(res.data) ? res.data[0] : res.data
              const prod = this.order.positions[0].article.product;
              if (prod.category === 'VOU') {
                this.$api.get(`/vouchers?orderedInId=${this.order.id}`)
                    .then(res => this.voucher = {...res.data, id: res.data.code})
                    .catch(error => this.handleError(error))
              }
            })
            .catch(err => this.handleError(err))
        this.$api.get(`/invoices`, {
          params: {
            order: this.order.id
          }
        }).then(res => this.invoice = res.data)
            .catch(err => this.handleError(err))
      }
    },
    async cancel() {
      await this.$api.delete(`/orders/${this.order.id}`)
          .then(() => {
            this.showInfo('Die Rechnung wurde storniert.')
          })
          .catch((err) => this.handleError(err))
      await this.loadOrder()
    },
    async markAsFulfilled(blockCommunication) {
      await this.$api.put(`/orders/${this.order.id}/state`, {
        state: 'fulfilled',
        blockPostFulfillmentCommunication: blockCommunication
      })
          .then(() => this.loadOrder())
          .catch(error => this.handleError(error))
    },
    generateVoucher() {
      this.$api.put('/vouchers', null, {
        params: {
          order: this.order.id
        }
      }).then(() => this.loadOrder())
          .catch(err => this.handleError(err))
    },
    generateInvoiceAndSent() {
      this.$api.post(`/invoices`, {}, {
        params: {
          order: this.order.id
        }
      }).then((res) => {
        this.invoice = res.data
        this.showInfo("Rechnung generiert und gesendet")
      }).catch(error => this.handleError(error))
    }
  }
}
</script>
